
import {
    SEARCH_VACCINES_REQUEST,
    SEARCH_VACCINES_SUCCESS,
    SEARCH_VACCINES_FAILURE,
    ADD_VACCINE_REQUEST,
    ADD_VACCINE_SUCCESS,
    ADD_VACCINE_FAILURE,
    EDIT_VACCINE_REQUEST,
    EDIT_VACCINE_SUCCESS,
    EDIT_VACCINE_FAILURE,
    LOAD_VACCINE_REQUEST,
    LOAD_VACCINE_SUCCESS,
    LOAD_VACCINE_FAILURE,
    INITIALIZE_NEW_VACCINE,
    ADD_EDIT_VACCINE_VIEW,
    SEARCH_VACCINES_VIEW,
    CLEAR_VACCINE,
    VIEW_VACCINE_VIEW,

} from '../healthRecordActionTypes';
 
// Reducers
const initialState = {
    loading: false,
    vaccines: [],
    immunizations: [],
    error: '',

    vaccine: { 
        name:null, 
        isActive:true, 
        isRequired:null, 
        systemDefined:false, 
        allowExemption:null 
    },
    activeView: SEARCH_VACCINES_VIEW,
    urlPath:'/student-life/health-record/vaccines'

};

const vaccinesReducer = (state = initialState, { type, payload}) => {
    switch (type) {
        case CLEAR_VACCINE:
            return {...initialState};
        case SEARCH_VACCINES_REQUEST:
        case ADD_VACCINE_REQUEST:
        case EDIT_VACCINE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case SEARCH_VACCINES_SUCCESS:
            return {
                ...state,
                loading: false,
                vaccines: payload,
                urlPath:'/student-life/health-record/vaccines/search',
                error: ''
            };
        case INITIALIZE_NEW_VACCINE:
            return {
                ...state,
                vaccine: { name:null,isActive:true, isRequired:null, systemDefined:false, allowExemption:null },
                activeView: ADD_EDIT_VACCINE_VIEW,
                urlPath:'/student-life/health-record/vaccines/add'
            }
        case ADD_VACCINE_SUCCESS:
        case EDIT_VACCINE_SUCCESS:
            return {
                ...state,
                loading: false,
                vaccines:[],
                error: ''
            };
        case LOAD_VACCINE_SUCCESS:
            return {
                ...state,
                loading: false,
                vaccine: payload,
                error: ''
            };
        case LOAD_VACCINE_REQUEST:            
            return {
                ...state,
                loading: true,
                activeView: payload.action !== 'view' ? ADD_EDIT_VACCINE_VIEW :VIEW_VACCINE_VIEW,
                urlPath:`/student-life/health-record/vaccines/${payload.action}/${payload.vaccineID}`,
                error: ''
            };
        case SEARCH_VACCINES_FAILURE:
        case ADD_VACCINE_FAILURE:
        case EDIT_VACCINE_FAILURE:
        case LOAD_VACCINE_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            return state;
    }
};

export default vaccinesReducer;